// Anki-style spaced repetition (SM-2 family) for the lesson system's flash
// cards. Pure: time flows in as `now` (ms epoch), state is a plain record
// the deck persists. A "again" answer relearns in minutes; graduated cards
// space out in days multiplied by an ease that drifts with performance.

{max, min, round} := Math

export type Rating = "again" | "hard" | "good" | "easy"

export type CardState =
  // ms epoch when the card is next due
  due: number
  // days between reviews once graduated; 0 = (re)learning
  interval: number
  // interval multiplier, drifts with performance (Anki's ease factor)
  ease: number
  reps: number
  lapses: number
  // lifetime answer tally, for the stats display
  correct: number
  incorrect: number

RELEARN_MS := 10 * 60 * 1000
DAY_MS := 24 * 60 * 60 * 1000
MIN_EASE := 1.3

export newCardState := (now: number): CardState ->
  due: now
  interval: 0
  ease: 2.5
  reps: 0
  lapses: 0
  correct: 0
  incorrect: 0

export isDue := (state: CardState, now: number) ->
  state.due <= now

export review := (state: CardState, rating: Rating, now: number): CardState ->
  {interval, ease, reps, lapses, correct, incorrect} .= state

  reps++
  switch rating
    "again"
      incorrect++
      lapses++
      ease = max MIN_EASE, ease - 0.2
      interval = 0
      return {due: now + RELEARN_MS, interval, ease, reps, lapses, correct, incorrect}
    "hard"
      correct++
      ease = max MIN_EASE, ease - 0.15
      interval = max 1, round interval * 1.2
    "good"
      correct++
      interval = if interval < 1 then 1 else max interval + 1, round interval * ease
    "easy"
      correct++
      ease += 0.15
      interval = max 2, round interval * ease * 1.3

  // spread same-day graduations a touch so a burst doesn't all land at once
  {due: now + interval * DAY_MS, interval, ease, reps, lapses, correct, incorrect}
